import { environment } from './environments/environment';

export const API_VERSIONs = {
  VERSION_1_0_0: '1.0.0',
  VERSION_2_0_0: '2.0.0',
};

export const API_ENDPOINTS = {
  auth: `${environment.domain.apiAuth}`, // <<-- API AUTH
  //#region Project Admin quan ly permission
  permission_v2_file_v2: `${environment.domain.apiAuth}/permission-v2/file-v2`,
  /**
   * Permission v2 admin api
   */
  permission_v2_confApp: `${environment.domain.apiAuth}/conf-app`,
  permission_v2_confApi: `${environment.domain.apiAuth}/conf-api`,
  permission_v2_confMenu: `${environment.domain.apiAuth}/conf-menu`,
  permission_v2_confRole: `${environment.domain.apiAuth}/conf-role`,
  permission_v2_confUserManage: `${environment.domain.apiAuth}/conf-user-manage`,
  //#endregion

  // Api chua phan loai drive
  chua_phan_loai_drive: `${environment.domain.apiChuaPhanLoai}/drive`,
  /**
   * Thông báo sinh viên cho panel `/workspace`.
   *
   * Module riêng ở service `chua-phan-loai`, cố ý KHÔNG dùng chung `/drive` với
   * dashboard cũ và Sổ tay sinh viên: lọc theo niên khóa, thay key cá nhân hoá
   * và xếp hạng chỉ áp cho thông báo.
   */
  thong_bao_sinh_vien: `${environment.domain.apiChuaPhanLoai}/thong-bao-sinh-vien`,
  sinh_vien_dashboard: `${environment.domain.apiElearningV3}/sinh-vien-dashboard`,
  mThongTinSinhVien: `${environment.domain.apiHoSoCaNhanV2}`,

  //#region ĐƠN PHIẾU ONLINE — VIỆN HTPTĐT
  don_phieu_online_vien_htptdt_sinh_vien: `${environment.domain.apiDonPhieuOnlineVHTPTDT}/don-phieu-dang-ky`,
  don_phieu_online_vien_htptdt_bieu_mau: `${environment.domain.apiDonPhieuOnlineVHTPTDT}/don-phieu-bieu-mau`,
  don_phieu_online_vien_htptdt_config: `${environment.domain.apiDonPhieuOnlineVHTPTDT}/don-phieu-config`,
  //#endregion

  //#region HỎI ĐÁP (ticket-management)
  ticket_confTicketType: `${environment.domain.apiTicketManagement}/conf-ticket-type`,
  ticket_knowledge: `${environment.domain.apiTicketManagement}/knowledge`,
  ticket_feedback: `${environment.domain.apiTicketManagement}/feedback`,
  ticket_file: `${environment.domain.apiTicketManagement}/file-v2`,
  ticket_sinhVien: `${environment.domain.apiTicketManagement}/tickets/sinh-vien`,
  /**
   * Nhánh QUẢN LÝ — cổng sinh viên KHÔNG có màn hình nào gọi tới, nhưng mã dùng
   * chung của `ticket-management` vẫn tham chiếu hằng số này nên phải khai.
   * ⚠ Đừng gán các đường dẫn `/tickets/quan-ly/*` cho vai trò sinh viên trong
   * permission-v2 (xem PRD S01 §14 — Phụ lục A.2, 6 dòng đánh dấu QL).
   */
  ticket_quanLy: `${environment.domain.apiTicketManagement}/tickets/quan-ly`,
  ticket_nam_hoc: `${environment.domain.apiTicketManagement}/nam-hoc`,
  //#endregion

  //#region HỌC VỤ — dịch vụ `api-elearning` (V1)
  elearning_lop_hoc_phan: `${environment.domain.apiElearningV2}/lop-hoc-phan`,
  elearning_thong_bao: `${environment.domain.apiElearningV2}/newsletters`,
  elearning_lich_trinh_giang_day: `${environment.domain.apiElearningV2}/lop-hoc-phan/giang-vien/lich-trinh`,
  elearning_hoc_ky_sinh_vien: `${environment.domain.apiElearningV2}/lop-hoc-phan/sinh-vien/nam-hoc-hoc-ky`,
  //#endregion

  //#region HỌC VỤ — dịch vụ `api-elearning-v2` (V2)
  elearning_m_sinh_vien_lich_thi: `${environment.domain.apiElearningV2}/lich-thi-sinh-vien`,
  elearning_m_sinh_vien_xem_diem: `${environment.domain.apiElearningV2}/diem-sinh-vien`,
  elearning_m_sinh_vien_thoi_khoa_bieu: `${environment.domain.apiElearningV2}/tkb-sinh-vien`,
  elearning_nam_hoc_sinh_vien: `${environment.domain.apiElearningV2}/nam-hoc-hoc-ky`,
  //#endregion
};
